import { graphql } from "msw";
import { 
    mockWorkflowModel
} from "./mockmodelstates";

let wfModel = { ...mockWorkflowModel };

export const handlers = [
    graphql.query("loadActiveWorkflowModel", (req, res, ctx) =>
        res(ctx.delay(), ctx.data({ currentProject: {
            _id: "1",
            __typename: "Project",
            activeWorkflowModel: wfModel
        } }))
    ),
    graphql.mutation("updateWorkflowModel", (req, res, ctx) => {
        wfModel = req.variables.input;
        return res(ctx.delay(), ctx.data({ 
            updateWorkflowmodel: wfModel
        }));
    }
    ),
    
];
